import { render, staticRenderFns } from "./UserRoleForm.vue?vue&type=template&id=3bc42d4d&"
import script from "./UserRoleForm.vue?vue&type=script&lang=ts&"
export * from "./UserRoleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports